import { NgModule } from '@angular/core';

import { StickyComponent } from './component/sticky.component';

@NgModule({
  declarations: [StickyComponent],
  exports: [StickyComponent]
})
export class StickyModule { }
